/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.col-mapped[_ngcontent-%COMP%]   select[_ngcontent-%COMP%] {\n    width: 200px;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvY29tcG9uZW50cy9wb3J0YWwvc2V0dGluZ3MtbmluamEvbmluamEtc3lzdGVtLWNvbHVtbi1tYXBwaW5nL25pbmphLXN5c3RlbS1jb2x1bW4tbWFwcGluZy5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvY29tcG9uZW50cy9wb3J0YWwvc2V0dGluZ3MtbmluamEvbmluamEtc3lzdGVtLWNvbHVtbi1tYXBwaW5nL25pbmphLXN5c3RlbS1jb2x1bW4tbWFwcGluZy5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/portal/settings-ninja/ninja-system-column-mapping/ninja-system-column-mapping.component.css.shim.ngstyle.ts